import { makeHttpClient, _unwrapAxiosResponse } from "./http";

import env from "../environment/env.json";

export class DashboardDataService {
  private httpClient = makeHttpClient();

  getReportStatusOverview(defaultView: boolean, customer_id: number) {
    let url = `${env.dashboardUrl}report-status-overview/`;
    if (defaultView != null) {
      url = url + "?default_view" + "=" + defaultView;
    }
    if (customer_id != null) {
      url = url + `&customer=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getIncompleteReportTracker(
    sortBy: any = null,
    defaultView: boolean,
    customer_id: number,
    query: any
  ) {
    let url = `${env.dashboardUrl}report-list/`;
    if (sortBy != null && defaultView != null) {
      url = url + `?order_field=${sortBy}&default_view=${defaultView}`;
    }
    if (customer_id != null) {
      url = url + `&customer=${customer_id}`;
    }
    if (query) {
      url = `${url}${query}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getUpdatesList(
    defaultView: boolean,
    params: string,
    customer_id: number,
    query: any
  ) {
    let url = `${env.dashboardUrl}updates-list/?default_view=${defaultView}&`;
    if (params != null) {
      url = url + params;
    }
    if (customer_id != null) {
      url = url + `&customer=${customer_id}&`;
    }
    if (query) {
      url = `${url}${query}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }
  getUpdateById(id: number) {
    const url = `${env.dashboardUrl}updates-list/${id}/`;
    //console.log(url);
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getActivityList(defaultView: boolean, params: string, query: any) {
    let url = `${env.dashboardUrl}activity/list/?default_view=${defaultView}&`;
    if (params != null) {
      url = url + params;
    }
    if (query) {
      url = `${url}${query}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  getEventList(defaultView: boolean, params: string, customer_id: number) {
    let url = `${env.dashboardUrl}calendar/events/list/?default_view=${defaultView}&`;
    if (params != null) {
      url = url + params;
    }
    if (customer_id != null) {
      url = url + `&customer=${customer_id}`;
    }
    return _unwrapAxiosResponse(this.httpClient.get(url));
  }

  updateDashboardUpdateStatus(data: any) {
    return _unwrapAxiosResponse(
      this.httpClient.put(
        `${env.dashboardUrl}updates-list/` + `${data.id}/`,
        data
      )
    );
  }
}

export default DashboardDataService;
